export var ContentstackImageFormatEnum;
(function (ContentstackImageFormatEnum) {
    ContentstackImageFormatEnum["Gif"] = "gif";
    ContentstackImageFormatEnum["Jpg"] = "jpg";
    ContentstackImageFormatEnum["Pjpg"] = "pjpg";
    ContentstackImageFormatEnum["Png"] = "png";
    ContentstackImageFormatEnum["Webp"] = "webp";
    ContentstackImageFormatEnum["Webpll"] = "webpll";
    ContentstackImageFormatEnum["Webply"] = "webply";
})(ContentstackImageFormatEnum || (ContentstackImageFormatEnum = {}));
export const DEFAULT_OPTIMIZED_IMAGE_QUERY_PARAMS = {
    // Enables WebP image support. In browsers that do not support WebP format, the format parameter will be applied
    auto: 'webp',
    // Compression level of image
    quality: '75',
};
//# sourceMappingURL=image.js.map